module.exports = __webpack_public_path__ + "static/educative-walkthrough-7677fd176337186a79e691c772133b5b.webm";